export const NAME = 'Nasze Górskie';
export const ADDRESS_LINE_1 = 'ul. Pomarańczowa 2';
export const ADDRESS_LINE_2 = '58-560 Wojcieszyce';
export const PHONE_1 = '+48 665 209 664';
export const PHONE_2 = '+48 608 198 815';
export const EMAIL = 'kontakt@naszegorskie.pl';
